import createReducer from '../createReducer'
import {
  FETCH_USER_STATS_SUCCESS,
} from './constants'

export const initialState = {}

export default createReducer(initialState, {

  [FETCH_USER_STATS_SUCCESS]: (state, action) => {
    const { stats, summary_stats } = action.payload.data._embedded
    return {
      ...state,
      stats,
      summary_stats,
    }
  },

})
